import React, { useEffect, useState } from 'react';
import { useTitle } from 'react-use';
// import { Link } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';

import clienteAxios from 'config/axios';
import Carrera from 'components/carrera/carrera';
import Header from 'components/header/header';

import {mostrarAlerta} from 'actions/alertaActions';
import {useSelector, useDispatch} from 'react-redux';

// import tid_btn from 'img/tid-btn.svg';

function Home({openMenu, setOpenMenu}) {

    const dispatch = useDispatch();

    const usuario = useSelector( state => state.usuario.usuario );

    const [dataCarreras, setDataCarreras] = useState(null);
    const [loading, setLoading] = useState(true);   

    //const [lastAccessTids, setLasAccessTids] = useState([]);

    const token = useSelector((state) => state.usuario.token);

    useTitle("Colegio Universitario IES - Mis materias");



    useEffect(() => { 
        if((!usuario || Object.keys(usuario).length > 0) && token && !dataCarreras){
            const fetchTids = async () => {

                setLoading(true);

                const data = { token };

                try {
                    const result = await clienteAxios.post('get_tids.php', data);

                    console.log(result);               
        
                    if(result.data.r === 0){
                        dispatch(mostrarAlerta(result.data.text, "Error"));
                        setLoading(false);
                        return false;
                    }
                    
                    console.log(result.data.carreras)
                    if(result.data.carreras){
                        setDataCarreras({
                                alumno: result.data.carreras,
                                moderador: result.data.carrerasModerador,
                            });
                    }
        
                }catch (error) {
                    dispatch(mostrarAlerta(error, "Error"));
                }
                setLoading(false);
            }
            fetchTids();
        }
        // eslint-disable-next-line
    }, [token, usuario]);

    if(!usuario || Object.keys(usuario).length < 1) return null;
    
    return (
        <div className="home">

            <Header 
                titulo={!loading ? '' : 'Cargando datos...'} 
                avatarData = {usuario}
                utilesVisible={false}
                paginaRef={undefined}
                loading={loading}
                setOpenMenu={setOpenMenu} 
                openMenu={openMenu}
                imagesLoaded = {false}
                isTid = {false}
                showPreguntasBtn={false}
                showPreguntas={undefined}
                openPreguntas={false}
                showUtilsBtn={false}
                showUtils={undefined}
                openUtils={false}
                sendAction = {undefined}
            />

            <div className="section flex nosombra pl0 pr0"> 

            { (token && dataCarreras) ?
                <>
                    { dataCarreras.moderador.length > 0 ?
                    <>
                        <h4 className="h4HomeSub">Carreras docente</h4>
                        <div className="carreras">
                            {   dataCarreras.moderador.map( carrera => {                    
                                    return (
                                        <Carrera key={carrera.id} data={carrera} />
                                    )
                                })
                            }
                        </div>
                        <hr />
                    </>
                    : null }

                    { dataCarreras.alumno.length > 0 ?

                    <>
                    { dataCarreras.moderador.length > 0 ? <h4 className="h4HomeSub">Carreras alumno</h4> : null}

                    <div className="carreras">
                        {   dataCarreras.alumno.map( carrera => {                    
                                return (
                                    <Carrera key={carrera.id} data={carrera} />
                                )
                            })
                        }
                    </div>
                    </>

                    : null }
                    
                </>
            :

                <div className="carreras">
                    <h1><Skeleton /></h1>

                    <ul className="anios">
                        <li className="desplegado">
                            <div className="li"><Skeleton /></div>
                            <ul className="materia">
                                <li><Skeleton /></li>
                                <li><div className="li"> <span className="txt_ma"><Skeleton /></span></div></li>
                                <li><div className="li"> <span className="txt_ma"><Skeleton /></span></div></li>
                                <li><div className="li"> <span className="txt_ma"><Skeleton /></span></div></li>
                                <li><div className="li"> <span className="txt_ma"><Skeleton /></span></div></li>
                                <li><div className="li"> <span className="txt_ma"><Skeleton /></span></div></li>
                            </ul>
                        </li>
                    </ul>

                    <ul className="anios">
                        <li className="desplegado">
                            <div className="li"><Skeleton /></div>
                            <ul className="materia">
                                <li><Skeleton /></li>
                                <li><div className="li"> <span className="txt_ma"><Skeleton /></span></div></li>
                                <li><div className="li"> <span className="txt_ma"><Skeleton /></span></div></li>
                                <li><div className="li"> <span className="txt_ma"><Skeleton /></span></div></li>
                                <li><div className="li"> <span className="txt_ma"><Skeleton /></span></div></li>
                                <li><div className="li"> <span className="txt_ma"><Skeleton /></span></div></li>
                            </ul>
                        </li>
                    </ul>

                </div>
            }
            </div>
        </div>
    );
}

export default React.memo(Home, (prevProps, nextProps) => {
    // console.log({prevProps, nextProps})
    return prevProps.token === nextProps.token
});
